import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";

export class WidgetsColumnModel extends WidgetsContainerAbstract {
    readonly icon: string = 'view_column';
    readonly name: string = 'Column';
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.COLUMN;
    template = '';
    readonly badge: string = 'C';
    readonly placeholderClassName: string = 'column-placeholder';
    width?: number;                                         // If width is not present, it will be auto calculated
    ordinal?: number;                                       // ordinal of the column in the row
    columnNumber?: number;                                  // total number of columns in the row
    children: WidgetsAbstract[] = [];

    toJSON() : any {
        return {
            badge: this.badge, 
            widgetType: this.widgetType,             
            id: this.id,
            parentId: this.parentId,
            width: this.width, 
            template: this.template ? this.template : undefined,
            children: this.children 
        };
    }

    cloneFrom(origin: WidgetsColumnModel) : WidgetsColumnModel {
        this.width = origin.width;
        if(origin.template){
            this.template = origin.template;
        }
        return this;
    }   
}